import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	import {
		getCurrentInstance,
		provide
	} from 'vue'

	
	const __default__ = { name: 'VField' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

	provide('fieldDisabled', props.disabled)

	const controlId = 'control-' + getCurrentInstance()?.uid
	provide('controlId', controlId)

	const labelId = 'label-' + getCurrentInstance()?.uid
	provide('labelId', labelId)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(clsx)(
			'[&>[data-slot=label]+[data-slot=control]]:mt-1',
			'[&>[data-slot=label]+[data-slot=description]]:mt-1',
			'[&>[data-slot=description]+[data-slot=control]]:mt-3',
			'[&>[data-slot=control]+[data-slot=description]]:mt-3',
			'[&>[data-slot=control]+[data-slot=error]]:mt-3',
			'[&>[data-slot=label]]:font-medium'
		))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})